<template>
  <report-filter-autocomplete-object
  :label="$t(label)"
  v-model="model"
  @input="$emit('selected')"
  item-text="name"
  item-value="key"
  :normal="normal"
  :items="categories"
  :outlined="outlined"
  :loading="loading"
  :placeholder="placeholder"
  :required="required"/>
</template>

<script>
import ReportFilterAutocompleteObject from '@/components/report/ReportFilterAutocompleteObject'

import { execHttpRequestThrowable } from '@/services/http'
import { fetchAllCategories } from '@/repositories/partRepo'

export default {
  components: {
    ReportFilterAutocompleteObject
  },
  props: {
    value: {
      type: Object,
      default: null  
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: null
    },
    normal: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    outlined: Boolean,
  },
  model: {
    prop: "value",
    event: "valueChanged"
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit("valueChanged", v)
      }
    }
  },
  data: () => {
    return {
      categories: [],
      loading: true
    }
  },
  methods: {
    async tryToFetchAllCategories() {
      try {
        this.loading = true
        const r = await execHttpRequestThrowable(fetchAllCategories)
        this.categories = [...r.response.data]
      }
      finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    await this.tryToFetchAllCategories()
  }
}
</script>

<style>

</style>